module.exports = __webpack_public_path__ + "static/media/technology-solution.3fbc2d2a.svg";